const getters = {
  scrollbarTag: (state) => {
    return state.is_touch_device ? "div" : "VuePerfectScrollbar";
  },
};

export default getters;
